import { BRAND_COLORS } from "../lib/bookingStatus";
import { useI18n } from "../lib/i18n";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
export default function Impressum() {
  const { lang } = useI18n();
  const de = lang !== "en";
  const navigate = useNavigate();
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));
  return (
    <div className="min-h-screen" style={{ background: BRAND_COLORS.ivory }} data-testid="impressum-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <button
          type="button"
          onClick={goBack}
          data-testid="legal-back-btn"
          className="inline-flex items-center gap-2 text-[11px] tracking-widest uppercase text-navy-dark/70 hover:text-gold transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.8} /> {de ? "Zurück" : "Back"}
        </button>
        <div className="label-caps mb-3">{de ? "Rechtliches" : "Legal"}</div>
        <h1 className="font-display text-4xl md:text-5xl text-navy mb-4">{de ? "Impressum" : "Imprint"}</h1>
        <p className="text-[13px] text-navy-dark/60 italic mb-10">
          {de ? "Angaben nach § 5 TMG / DL-InfoV" : "Legal notice according to § 5 TMG / DL-InfoV (content kept in German for legal accuracy)"}
        </p>

        <section className="space-y-8 text-[14.5px] leading-relaxed text-navy-dark">
          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Anbieter des Internetangebotes</div>
            <p className="text-[13px] text-navy-dark/70 italic mb-3">
              Immobilienbetreuung für Privathäuser & Zweitwohnsitze in München, Tegernsee und Bayern
            </p>
            <p className="text-navy font-medium text-[15px]">
              Weissblom GbR<br />
              Pfaffensteig 22a<br />
              82041 Oberbiberg<br />
              Deutschland
            </p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Kontakt</div>
            <p>
              E-Mail: <a href="mailto:info@weissblom.de" className="text-navy border-b border-gold hover:text-gold transition-colors">info@weissblom.de</a><br />
              Web: <a href="https://www.weissblom.de" target="_blank" rel="noreferrer" className="text-navy border-b border-gold hover:text-gold transition-colors">www.weissblom.de</a>
            </p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Registergericht</div>
            <p>Amtsgericht München</p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Berufsaufsicht</div>
            <p>
              IHK für München und Oberbayern<br />
              Max-Joseph-Straße 2<br />
              80333 München
            </p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Umsatzsteuer-Identifikationsnummer</div>
            <p>gemäß § 27a UStG: <span className="text-navy font-medium">DE367275359</span></p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Verbraucherinformation zur Online-Streitbeilegung</div>
            <p>
              Gemäß Verordnung (EU) Nr. 524/2013 stellt die Europäische Kommission eine Plattform zur Online-Streitbeilegung bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer" className="text-navy border-b border-gold hover:text-gold transition-colors">
                ec.europa.eu/consumers/odr
              </a>.
            </p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Urheberrecht</div>
            <p className="text-navy-dark/85">
              Der Inhalt dieser Website ist urheberrechtlich geschützt. Alle Rechte an Texten, Grafiken und Bildern verbleiben bei den Urhebern bzw. Inhabern anderer Schutzrechte. Eine Vervielfältigung oder öffentliche Wiedergabe in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung der Rechtsinhaber nicht gestattet.
            </p>
            <p className="text-navy-dark/85 mt-3">
              Wir erklären, dass wir nach bestem Wissen und Gewissen nur Inhalte und Gestaltungselemente verwenden, deren Rechtsinhaber wir sind oder die frei von Schutzrechten Dritter sind. Sollten Sie der Auffassung sein, dass durch Inhalte oder Gestaltungselemente dieser Website Schutzrechte Dritter verletzt werden, bitten wir um kurze Mitteilung zur Überprüfung.
            </p>
          </div>

          <div>
            <div className="label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>Bildnachweise</div>
            <p className="text-[13px] text-navy-dark/70 leading-relaxed">
              © Oleh_Slobodeniuk · © Ilija Erceg · © YKvision · © tulcarion · © AJ165 · © Sheremetio · © Followtheflow · © Iva-Prime
            </p>
          </div>
        </section>

        <div className="mt-16 pt-8 border-t border-navy/10 flex gap-6 text-[11px] tracking-widest uppercase text-navy-dark/60">
          <Link to="/datenschutz" className="hover:text-gold transition-colors">{de ? "Datenschutz" : "Privacy"}</Link>
          <a href="/login" className="hover:text-gold transition-colors">{de ? "Zur Anmeldung →" : "To sign-in →"}</a>
        </div>
      </div>
    </div>
  );
}
